import React, { useState } from "react";

import moment from "moment";
import _ from "lodash";
import { Button, Form, Alert, Modal, ProgressBar } from "react-bootstrap";

const JobEvidence = (props) => {
  const [files, setFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const userJob = props.userJob;
  const editMode = _.get(props, "edit", false);

  const evidenceSubmit = (e) => {
    let frm = e.currentTarget;
    e.preventDefault();

    if (files.length > 0) {
      setSubmitting(true);
      let formData = new FormData();
      formData.append("ujid", userJob.id);
      formData.append("na", "0");
      files.forEach((f) => formData.append("evidence[]", f));
      props.userJobSubmit(formData).then(() => setSubmitting(false));
    } else {
      window.alert("Please select your evidence file!");
      return false;
    }
  };

  const setFile = (e) => {
    setFiles([...files, e.currentTarget.files[0]]);
    e.currentTarget.value = "";
  };

  const removeFile = (idx) => (e) => {
    setFiles(files.filter((f, ctr) => ctr != idx));
  };

  const uploadForm = () => {
    return (
      <>
        {files.map((f, idx) => (
          <div key={idx}>
            <div className="d-flex">
              <div className="w-100 float-left text-truncate">{f.name}</div>
              <div className="float-right px-2">
                <img
                  src={`${process.env.PUBLIC_URL}/images/delete.png`}
                  className="clickable"
                  title="Remove"
                  onClick={removeFile(idx)}
                />
              </div>
            </div>
            <hr />
          </div>
        ))}
        <div className="d-flex">
          <div className="w-100 float-left">
            <Form.Control type="file" name="evidence" onChange={setFile} />
          </div>
          <div className="float-right px-2">
            <img src={`${process.env.PUBLIC_URL}/images/delete-d.png`} />
          </div>
        </div>
      </>
    );
  };

  const showAsForm = () => {
    return (
      <Form onSubmit={evidenceSubmit} encType="multipart/form-data">
        <Form.Label>
          <b>Add more Evidence file</b>
        </Form.Label>
        {uploadForm()}
        <div className="mt-2 text-end">
          {!submitting && (
            <>
              <Button variant="primary" type="submit" className="mx-1">
                Complete
              </Button>
              <Button
                variant="secondary"
                className="mx-1"
                onClick={props.onHide}
              >
                Close
              </Button>
            </>
          )}
          {submitting && (
            <Alert variant="success" className="p-3">
              <p className="loading-msg">Saving.. please wait..</p>
              <ProgressBar variant="success" animated now={100} />
            </Alert>
          )}
        </div>
      </Form>
    );
  };

  const showAsModal = () => {
    return (
      <Modal size="lg" show onHide={props.onHide} centered>
        <Form onSubmit={evidenceSubmit} encType="multipart/form-data">
          <Modal.Header closeButton>
            <Modal.Title>Job Evidence</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <Alert variant="info" className="p-2">
              <b>{JSON.parse(userJob.jobdetails)["name"]}</b>
              <hr />
              Due by: {moment(userJob.job_date).format("DD-MMM-YYYY")}
            </Alert>
            <div className="card p-2">
              <Form.Label>
                <b>Upload your Evidence file</b>
              </Form.Label>
              {uploadForm()}
            </div>
          </Modal.Body>
          <Modal.Footer>
            {!submitting && (
              <>
                <Button variant="primary" type="submit">
                  Complete
                </Button>
                <Button variant="secondary" onClick={props.onHide}>
                  Close
                </Button>
              </>
            )}
            {submitting && (
              <Alert variant="success" className="p-3">
                <p className="loading-msg">Saving.. please wait..</p>
                <ProgressBar variant="success" animated now={100} />
              </Alert>
            )}
          </Modal.Footer>
        </Form>
      </Modal>
    );
  };

  return (
    <>
      {!editMode && showAsModal()}
      {editMode && showAsForm()}
    </>
  );
};

export default JobEvidence;
